import { humanizeOutputColumnKey } from "./automationOutputTableUtils";

export const DEFAULT_AUTOMATION_FILTER_OPTIONS = [
  { id: "", label: "All fields", apiColumn: null },
  { id: "workflow_name", label: "Workflow", apiColumn: "workflow_name" },
  { id: "status", label: "Status", apiColumn: "status" },
  { id: "workflow_key", label: "Type", apiColumn: "workflow_key" },
];

export const buildAutomationFilterOptions = (listColumns) => {
  if (!Array.isArray(listColumns) || listColumns.length === 0) {
    return DEFAULT_AUTOMATION_FILTER_OPTIONS;
  }

  return [
    { id: "", label: "All fields", apiColumn: null },
    ...listColumns.map((key) => ({
      id: key,
      label: humanizeOutputColumnKey(key),
      apiColumn: key,
    })),
  ];
};

export const resolveAutomationSearchColumn = (filterId, filterOptions) => {
  if (!filterId) return null;
  const match = filterOptions.find((opt) => opt.id === filterId);
  return match?.apiColumn ?? filterId;
};

export const WORKFLOW_KEY_OPTIONS = [
  { value: "agent_only", label: "Agent Only" },
  { value: "data_import", label: "Data Import" },
  { value: "invoice_import", label: "Invoice Import" },
  { value: "single_agent", label: "Single Agent" },
];

export const getWorkflowKeyLabel = (value) => {
  const match = WORKFLOW_KEY_OPTIONS.find((opt) => opt.value === value);
  return match?.label ?? value ?? "—";
};
